import {Controller} from "stimulus"

export default class extends Controller {

    static targets = [
      'pop',
    ]

    initialize(){
    }

    toggle(e){
      let that = e.currentTarget
      let buttonNumber = that.getAttribute("data-button-number")
      let buildClassNumber = "button-radio-" + buttonNumber
      let buttons = document.getElementsByClassName(buildClassNumber)

      for (let i = 0; i < buttons.length; i++) {
        buttons[i].classList.remove("is-active")
      }

      that.classList.add('is-active')


      //pop message
      let total = document.querySelectorAll('.button--grey').length // nbr de bouton total
      total = total/2 //2 choix par question

      let elementActive = document.querySelectorAll('.is-active')
      let elementActiveLength = elementActive.length
      let finalResult = true;

      if(elementActiveLength === total){
        for (let i = 0; i < elementActive.length; i++) {
          let result = elementActive[i].getAttribute('data-result')
          if (result === 'false') {
            finalResult = false
          }
        }


        let windowHeight = window.innerHeight
        window.scroll(0, windowHeight);

        if (finalResult !== false) {
          this.popTarget.classList.remove('is-active--neg')
          this.popTarget.classList.add('is-active--pos')
        }else{
          this.popTarget.classList.remove('is-active--pos')
          this.popTarget.classList.add('is-active--neg')
        }

      }
    }
}
